var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { property, query } from 'lit/decorators.js';
import { html, css } from 'lit';
import { classMap } from 'lit/directives/class-map.js';
import { styleMap } from 'lit/directives/style-map.js';
import { live } from 'lit/directives/live.js';
import { PICIsNumeric, PICIsInteger, PICValidate, numberDecoder, stringDecoder, customElement, PICInput } from '../Internals';
let PICNumber = class PICNumber extends PICInput {
    set pad(iPad) {
        this.pad_ = iPad.split('^');
        this.inpType = 'tel';
    }
    ;
    get pad() {
        return this.pad_.join('^');
    }
    get submitValue() {
        return this.inputField.value;
    }
    setValue(value) {
        if (value.length === 0) {
            this.invalidInputCycle = true;
            this.value = '';
        }
        else if (!isNaN(Number(value))) {
            this.invalidInputCycle = true; //to not use value of inputField in this specific case
            let nVal = Number(value);
            //Do not obey step rules, it would change input values without user input -> 7.82 (db) => 7.8 (js) => 7.8 (db)
            // let stepDecimals = Math.floor(nVal) !== nVal ? this.step.toString().split('.')[1].length : 0
            // if (stepDecimals > 0) nVal = Math.round((nVal + Number.EPSILON) * Math.pow(10, stepDecimals)) / Math.pow(10, stepDecimals); //When setting value, obey step rules
            this.value = nVal + '';
        }
        else
            console.warn('Attempting to set illegal value', value);
    }
    constructor() {
        super();
        this.step = "any";
        this.min = -Infinity;
        this.max = Infinity;
        this.inpType = 'number';
        this.didDeletion = false;
        this.allowDecimals = true;
        this.invalidInputCycle = false;
        this.pad_ = [];
    }
    static get styles() {
        const defaultStyle = css `
            :host {
                /* Makes the native number-input spin buttons render in the
                   correct light/dark palette - they aren't reachable via --pic-* vars. */
                color-scheme: var(--pic-colorScheme, light);
            }
            .inner-input-old {
                box-sizing: border-box;
                font-family: monospace;
            }

            input {
                -webkit-user-select: auto;
                -webkit-user-drag: none;
                user-select: auto;
            }
        `;
        return css `
            ${super.styles}
            ${defaultStyle}
        `;
    }
    connectedCallback() {
        super.connectedCallback();
        this.eType == 'default' ? this.eType = 'number' : this.eType = 'old';
        if (!this.valid)
            this.valid = new PICValidate([], this);
        let ref = this;
        if (typeof ref.step === 'number')
            this.valid.add((ref.step % 1 === 0) ? new PICIsInteger(ref, { ruleType: 'isint', value: true }) : new PICIsNumeric(ref, { ruleType: 'isnumeric', value: true }));
        else
            this.valid.add(new PICIsNumeric(ref, { ruleType: 'isnumeric', value: true })); //?
        if (this.step) {
            /*if(Number.isInteger(this.step)){
                this.inpType = 'tel';
            }*/
            if (Number.isInteger(Number(this.step)))
                this.allowDecimals = false;
        }
    }
    focus() {
        this.inputField.focus();
    }
    focusHandler(mode) {
        if (this.inputLabel) {
            if (mode == 'in') {
                this.density == 'low' && this.inputLabel.classList.contains('low') ? this.inputLabel.classList.remove('low') : '';
                this.density == 'medium' && this.inputLabel.classList.contains('medium') ? this.inputLabel.classList.remove('medium') : '';
                this.showFullError = true;
                this.requestUpdate();
            }
            if ((mode == 'out' && this.submitValue.length === 0) && (this.placeholder === null || this.placeholder.length === 0)) {
                //Float label back down, unless value or placeholder is sat
                this.density == 'low' ? this.inputLabel.classList.toggle('low') : '';
                this.density == 'medium' ? this.inputLabel.classList.toggle('medium') : '';
            }
            if (mode === 'out') {
                this.showFullError = false;
                this.requestUpdate();
            }
        }
    }
    enterSubmit(e) {
        if (e.key === ',' || e.key === '.') {
            if (!this.allowDecimals) {
                e.preventDefault();
                return;
            }
        }
        super.enterSubmit(e);
    }
    inputHandler(e) {
        this.didDeletion = (e.inputType == 'deleteContentBackward') || (e.inputType == 'deleteContentForward');
        let tmpInpVal = this.inputField.value;
        let prevVal = structuredClone(this.value);
        if (e.data === '+' || (tmpInpVal === '' && e.data === '-')) {
            this.invalidInputCycle = true;
        }
        else if (isNumeric(tmpInpVal)) {
            if (tmpInpVal.length === 0 && this.min <= 0 && e.data !== null) {
                // handle firefox and safari allowing letters in numeric input
                if (prevVal.length > 0) {
                    // if input is invalid, and a number was previously entered, go back to the previous value
                    if (isNaN(Number(e.data)) || e.data === ' ')
                        this.inputField.value = prevVal;
                }
                else
                    this.inputField.value = '';
            }
            if (this.min > tmpInpVal) {
                this.value = this.min + '';
                this.invalidInputCycle = true;
            }
            else if (this.max < tmpInpVal) {
                this.value = this.max + '';
                this.invalidInputCycle = true;
            }
            ;
        }
        ;
        if (!e.inputType) {
            let splitStep = this.inputField.step.split('.');
            let hasDecimals = splitStep.length > 1;
            let splitVal = this.inputField.value.split('.');
            if (hasDecimals) {
                let diff = splitVal.length > 1 && Boolean(splitStep[1]) ? splitStep[1].length - splitVal[1].length : splitStep[1].length;
                if (diff > 0) {
                    let tmpVal = this.inputField.value;
                    for (let index = 0; index < diff; index++) {
                        if (!tmpVal.includes('.'))
                            tmpVal += '.0';
                        else
                            tmpVal += '0';
                    }
                    this.inputField.value = tmpVal;
                }
            }
        }
        this.validate();
        function isNumeric(iVal) {
            return !isNaN(iVal.valueOf() * 1);
        }
    }
    updated(_changedProperties) {
        super.updated(_changedProperties);
        if (this.inpType == 'tel') {
            //set cursor position post update
            if (this.savedCaretPos !== null)
                this.inputField.setSelectionRange(this.savedCaretPos, this.savedCaretPos);
        }
        if (this.value !== '') {
            this.density == 'low' && this.inputLabel.classList.contains('low') ? this.inputLabel.classList.remove('low') : '';
            this.density == 'medium' && this.inputLabel.classList.contains('medium') ? this.inputLabel.classList.remove('medium') : '';
        }
    }
    willUpdate(_changedProperties) {
        var _a, _b, _c;
        //only do work if after first render
        if (this.inputField) {
            //remove non valid characters
            let newValue;
            // if invalid chars have been entered, use saved value
            if (this.invalidInputCycle) {
                newValue = this.value;
            }
            else {
                //if settings a value programatically, use setValue()
                newValue = this.inputField.value.replace(/[^\d.,-]+/g, '');
            }
            if (this.inpType == 'tel') {
                //save cursor position 
                this.savedCaretPos = this.inputField.selectionStart;
                //if padding enabled
                if (this.pad_.length > 0) {
                    let padDirection = (_a = this.pad_[0]) !== null && _a !== void 0 ? _a : 'L';
                    let padLength = (_b = parseInt(this.pad_[1])) !== null && _b !== void 0 ? _b : 0;
                    let padChars = (_c = this.pad_[2]) !== null && _c !== void 0 ? _c : 0;
                    //subtract 1 when padding to start to keep cursor behaving logically
                    if (padDirection !== 'R' && !this.didDeletion)
                        this.savedCaretPos--;
                    if (padDirection == 'R') {
                        //trim end if last char matches padchar and the string is too long
                        if (newValue.length > padLength && newValue.lastIndexOf(padChars) == newValue.length - 1) {
                            newValue = newValue.trimCharEnd(padChars);
                        }
                        newValue = newValue.padEnd(padLength, padChars);
                    }
                    else {
                        //trim start if first char matches padchar and the string is too long
                        if (newValue.length > padLength && newValue.indexOf(padChars) == 0) {
                            newValue = newValue.trimCharStart(padChars);
                        }
                        newValue = newValue.padStart(padLength, padChars);
                    }
                    //if string is still too long, remove inserted char
                    if (newValue.length > padLength) {
                        if (this.savedCaretPos == 0)
                            newValue = newValue.substring(1);
                        else
                            newValue = newValue.substring(0, this.savedCaretPos - 1) + newValue.substring(this.savedCaretPos);
                    }
                }
            }
            this.value = newValue;
            this.invalidInputCycle = false;
            this.setHasEllipsis();
        }
    }
    validate() {
        super.validate();
    }
    firstUpdated() {
        this.initValue_ = this.submitValue;
        if (this.inputLabel) {
            if (this.submitValue.length > 0) {
                this.density == 'low' && this.inputLabel.classList.contains('low') ? this.inputLabel.classList.remove('low') : '';
                this.density == 'medium' && this.inputLabel.classList.contains('medium') ? this.inputLabel.classList.remove('medium') : '';
            }
            else {
                this.density == 'low' && !this.inputLabel.classList.contains('low') ? this.inputLabel.classList.add('low') : '';
                this.density == 'medium' && !this.inputLabel.classList.contains('medium') ? this.inputLabel.classList.add('medium') : '';
            }
        }
        this.adjustRenderedWidth();
        this.requestUpdate();
    }
    render() {
        this.setComponentInlineStyle();
        //The step attribute below is erroneously reported as error, it can have a value of either a number or the keyword "any"
        return html `
            ${this.renderCSS(true)}
            <div style=${styleMap(this.getContainerStyle())} class=${classMap(this.getContainerClassMap())}>
                <label class=${classMap(this.classAdder(this.getInputLabelClass(), 'inner-inputLabel'))} for=${this.id_ + '_inner'}>${this.label}</label>
                <input
                    id=${this.id_ + '_inner'}
                    type=${this.inpType}
                    class=${classMap(this.getInnerInputClass())}
                    inputmode="numeric"
                    placeholder=${this.placeholder}
                    min=${this.min}
                    max=${this.max}
                    step=${this.step}
                    .value=${live(this.value)}
                    @focusin=${() => this.focusHandler('in')}
                    @focusout=${(e) => { this.changeHandler(e); this.focusHandler('out'); }}
                    @input=${this.inputHandler}
                    @keypress=${this.keyHandler}
                    @keydown=${this.enterSubmit}
                    ?disabled=${this.disabled_}
                    ?readonly=${this.readonly_}
                    />
                    ${this.icon.length > 0 ? this.renderIcon(this.disabled_) : ''}
                    ${this.renderErr(this.showFullError)}
            </div>
            ${this.tooltip_ ? html `<pic-tooltip>${this.tooltip_}</pic-tooltip>` : ''}
            ${!this.tooltip_ && this.hasEllipsis ? html `<pic-tooltip>${this.value}</pic-tooltip>` : ''}
        `;
    }
};
__decorate([
    query('.inner-input')
], PICNumber.prototype, "inputField", void 0);
__decorate([
    query('.inner-inputLabel')
], PICNumber.prototype, "inputLabel", void 0);
__decorate([
    property({ converter: (iVal) => {
            if (Number(iVal))
                return Number(iVal);
            return "any"; // "any" is a specific step value that allows all values, step is 1
        } })
], PICNumber.prototype, "step", void 0);
__decorate([
    property({ converter: numberDecoder })
], PICNumber.prototype, "min", void 0);
__decorate([
    property({ converter: numberDecoder })
], PICNumber.prototype, "max", void 0);
__decorate([
    property({ converter: stringDecoder, attribute: 'pad' })
], PICNumber.prototype, "pad", null);
PICNumber = __decorate([
    customElement('pic-number')
], PICNumber);
export { PICNumber };
//# sourceMappingURL=PICNumber.js.map